import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "close",
  "use": "close-usage",
  "viewBox": "0 0 500 500",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 500 500\" id=\"close\">\n  <g fill=\"none\" fill-rule=\"evenodd\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"26.322\" transform=\"translate(63 61)\">\n    <line x2=\"379.987\" y1=\"380\" y2=\".012\" />\n    <line x1=\".013\" x2=\"380\" y2=\"379.987\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol